import { createGlobalStyle } from 'styled-components'
import { Theme } from '@kyndio/kynd-shared-components'

// adds global styles directly to the styled-components stylesheet
// only included and run ONCE, in App.js
// this is done differently to external css because we want type checked control
// over themeing globals in here.
// For performance it's key that the amount of css in here is kept minimal
// as this will come down with every page load, in the HTML - it is not cached
// like the external css bundle

createGlobalStyle`
  * {
    box-sizing: border-box;
    outline: none;
  }

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    margin: 0;
    font-family: 'Lato',sans-serif;
    font-size: 20px;
    line-height: 1.42857143;
    color: ${Theme.colors.material.darkText.primary};
    min-width: 100%;
    display: inline-block;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* FIXME a hack to get semantic ui modals to position properly, SHOULD BE DELETED once design evolution is fully live */
  .ui.page.modals {
    z-index: ${Theme.layout.zIndex.modal};
  }
  .ui.modal {
    transform: translate(0%, -50%) !important;
    transform-origin: 50% 50% 0 !important;
  }

  /* FIXME this is a hack and should be done properly with semantic ui theming */
  label {
    color: rgba(0, 0, 0, 0.6) !important;
    font-family: Lato !important;
    font-size: 14px !important;
    letter-spacing: 0.25px !important;
    line-height: 20px !important;
  }
`
